import { render, staticRenderFns } from "./NewTaskInfo.vue?vue&type=template&id=2b07c096"
import script from "./NewTaskInfo.vue?vue&type=script&lang=js"
export * from "./NewTaskInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports